import React, { useState, useEffect } from "react";
import { Navbar, Image, Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import STRINGS from "../../constants/strings";
import "./styles.scss";

export default function Header(props) {
  const history = useHistory();
  const [scrolled, setScrolled] = useState(false);
  const { showLogin, handleLogout, loggedIn, categories, imageGallery } = props;

  const onScroll = () => {
    if (window.scrollY > 5) {
      setScrolled(true);
    }
    if (window.scrollY < 10) {
      setScrolled(false);
    }
  };

  useEffect(() => {
    onScroll();
    document.addEventListener("scroll", onScroll);
    return () => document.removeEventListener("scroll", onScroll);
  });

  return (
    <Navbar
      expand="lg"
      className={`home-nav ${scrolled ? "colored" : "transparent"} `}
      fixed="top"
    >
      {imageGallery ? (
        <Button
          className="landing-button"
          variant="outline-warning"
          onClick={() => history.push("/home")}
        >
          Home
        </Button>
      ) : (
        <Button
          className="landing-button"
          variant="outline-warning"
          onClick={() =>
            history.push("/image-gallery", {
              categories,
              loggedIn,
            })
          }
        >
          {STRINGS.IMAGE_GALLERY}
        </Button>
      )}
      <Image
        src={
          "https://sindhi-website-assets.s3.ap-south-1.amazonaws.com/logo.png"
        }
        className="header-logo"
        onClick={() => history.push("/home")}
      />
      <Button
        className="landing-button"
        variant="outline-warning"
        onClick={loggedIn ? handleLogout : showLogin}
      >
        {loggedIn ? STRINGS.LOGOUT : STRINGS.LOGIN}
      </Button>
    </Navbar>
  );
}
